<template>
  <v-app id="inspire">
    <v-container fluid id="mainFrame">
      <v-row>
        <v-col class="text-left" style="max-width: fit-content;">
          <IconTooltipButtonBottom
              @click="$router.push('/management')"
              icon="mdi-arrow-left"
              tooltip="Zurück"
              large
          />
<!--          <v-icon color="var(&#45;&#45;v-secondary-base)" large @click="$router.push('/management')">mdi-arrow-left</v-icon >-->
        </v-col>
        <v-col style="align-self: center">
          <h3>Nutzerverwaltung</h3>
        </v-col>
      <v-col class="text-right">
        <v-btn elevation="0" color="primary" @click="startNewUserMode()">
          <v-icon color="#F5F5F5" medium>add</v-icon > Nutzer hinzufügen
        </v-btn>
      </v-col>
      </v-row>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center">Aktionen</th>
              <th class="text-left">Nutzer-ID (E-Mail)</th>
              <th class="text-left">Name</th>
              <th class="text-left">Rollen</th>
              <th class="text-left">Nutzer Farbe</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users" :key="user.name">
              <td class="text-center" >
                <v-icon :id="roleEditable(user.userId) ? 'edit':'disabled'" @click="startEditMode(user)">edit</v-icon>
              </td>
              <td>{{ user.userId }}</td>
              <td>{{ user.fullName }}</td>
              <td>{{ listRoles(user) }}</td>
              <td> <v-avatar size="24" :color="user.iconColor"></v-avatar> <span
                  class="text-gray text-subtitle ml-2">{{
                  user.iconColor }}</span></td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-container>
    <AddUserDialog ref="addUserDialog"/>
  </v-app>
</template>

<script>
import userService from "@/components/userService"
import IconTooltipButtonBottom from "@/components/common/IconTooltipButtonBottom.vue"
import AddUserDialog from './Dialogs/AddUserDialog.vue';
export default {
  components:{
    IconTooltipButtonBottom,
    AddUserDialog
  },
  name: "adminPanel",

  data() {
    return {
      users: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    roleEditable(userId){
      if(userId == "superuser" || userId == "admin") return false;
      return true;
    },
    startNewUserMode(){
      this.$refs.addUserDialog
      .open()
      .then(() => {
        this.init();
      });
    },
    listRoles(user) {
      return user.roles.map(({ roleTitle }) => roleTitle).join(", ");
    },
    
    init() {
      userService.retrieveUsers().then((res) => {
        this.users = res.data;
      });
      // userService.retrieveUserColor(this.users.userId).then((res) => (this.users.user.iconColor = res.data));
    },
    startEditMode(user){
      if(!this.roleEditable(user.userId)) return;
      this.$refs.addUserDialog
      .open(user)
      .then(() => {
        this.init();
      });
    },
    fetchAvatar(userId) {
      userService.fetchUserColor(userId).then((res) => {
        let iconColor = "#"+res.data.iconColor
        return iconColor
      })
    }
  },
};
</script>

<style scoped>
#mainFrame {
  overflow: visible;
}
#disabled {
  cursor: not-allowed;
  color: gray
}
#edit{
  color: var(--v-primary-base)
}
.h3, h3{
  margin: 0;
}
</style>